//
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { authActions, authSelectors, authTypes } from 'app-components/flux/auth';
import { datasetsActions, datasetsSelectors } from 'app-components/flux/datasets';
import { preferencesV2Actions, preferencesV2Selectors } from 'app-components/flux/preferences-v2';
import { useFetchOnce } from 'app-components/hooks/utils';

import { getShareAcceptData, removeShareAcceptData } from 'data/app/helpers';

const useDatasetHandler = (props) => {
  const { authNotNeeded } = props;
  const dispatch = useDispatch();

  useFetchOnce(datasetsActions.getDatasets, datasetsSelectors, false, true);
  const entitledDatasetsLoadPending = useSelector(datasetsSelectors.getEntitledDatasetsLoadPending);

  // useFetchOnce(preferencesV2Actions.getPreferencesV2, preferencesV2Selectors, false, true); // TODO: QCS fix user scope
  useFetchOnce(preferencesV2Actions.getPreferencesV2, preferencesV2Selectors, false, false);

  const datasetsById = useSelector(datasetsSelectors.getEntitledDatasets);
  const datasetId = useSelector(authSelectors.getDatasetId);
  const qcsId = useSelector(authSelectors.getQCSId);

  // If datasets are loaded, handle selection: URL param takes precedence over automatic selection
  //
  useEffect(() => {
    if (datasetsById.size && !authNotNeeded && !entitledDatasetsLoadPending) {
      const params = new URLSearchParams(window.location.search);
      const datasetIdParam = params.get('datasetId');
      if (datasetIdParam && datasetIdParam !== datasetId) {
        const dataset = datasetsById.get(datasetIdParam);
        if (dataset && !qcsId) {
          return;
        }
        if (dataset && dataset.ownerId === qcsId) {
          params.delete('datasetId');
          const search = params.toString();
          const location = window.location.pathname + (search ? `?${search}` : '');
          dispatch(
            authActions.authSelectDataset(authTypes.AuthSelectDatasetPayload({ dataset, userChoice: false, location })),
          );
          return;
        }
      }

      if (!datasetId) {
        let dataset = null;
        const shareAcceptData = getShareAcceptData();
        if (shareAcceptData) {
          dataset = datasetsById.get(shareAcceptData.datasetId);
          removeShareAcceptData();
        }
        if (dataset) {
          dispatch(authActions.authSelectDataset(authTypes.AuthSelectDatasetPayload({ dataset, userChoice: true })));
        } else {
          dispatch(authActions.authSelectDatasetAuto({ reload: true, location: window.location.href }));
        }
      }
    }
  }, [datasetsById, datasetId, qcsId, authNotNeeded, dispatch, entitledDatasetsLoadPending]);
};

export default useDatasetHandler;
